<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Payment Receipt",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
      detail_id: atob(this.$route.params.detail_id),
      paid: atob(this.$route.params.paid),
      balance: atob(this.$route.params.balance),
      date: atob(this.$route.params.date),
    };
  },
  computed: {
    ...mapGetters("payments", ["PaymentReciept", "PaymentRecieptStatus"]),
  },
  methods: {
    ...mapActions({
      FetchPaymentReceipt: "payments/fetchPaymentReciept",
    }),
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // GET PAID
    getPaid(total) {
      let paid = total - this.balance;
      return this.thousandSeparator(paid);
    },
  },
  updated() {
    setTimeout(() => {
      window.print();
    }, 1000);
  },
  created() {
    this.FetchPaymentReceipt(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Reprint Receipt</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white p-2">
          <div class="print-font">
            <center>
              <b-spinner
                v-if="PaymentRecieptStatus"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <img
                v-else
                :src="PaymentReciept.clinic_logo ? PaymentReciept.clinic_logo : '--'"
                alt="Logo"
                height="70"
              />
              <br />
              <strong>
                {{
                  PaymentReciept.clinic_name ? PaymentReciept.clinic_name : "---"
                }}</strong
              >
              <p>
                <span>
                  {{
                    PaymentReciept.clinic_location
                      ? PaymentReciept.clinic_location
                      : "---"
                  }}</span
                >
                <br />
                {{
                  PaymentReciept.clinic_contact
                    ? "+256" + PaymentReciept.clinic_contact
                    : "---"
                }}
                <br />
                {{ PaymentReciept.clinic_email ? PaymentReciept.clinic_email : "---" }}
              </p>
              <h5
                style="
                  text-decoration: underline;
                  text-transform: uppercase;
                  text-align: center;
                  font-weight: bold;
                  font-family: Courier New, Courier, Lucida Sans Typewriter,
                    Lucida Typewriter, monospace;
                "
              >
                PAYMENT RECEIPT REPRINT
              </h5>
            </center>
            <hr style="border-style: dashed; width: 97%" />
            <center>
              <table width="100%">
                <tr>
                  <td><b>Date</b></td>
                  <td>{{ current_data }}</td>
                </tr>
                <tr>
                  <td><b>Name</b></td>
                  <td>
                    {{
                      PaymentReciept.patient_name ? PaymentReciept.patient_name : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Code</b></td>
                  <td>
                    {{
                      PaymentReciept.patient_number
                        ? PaymentReciept.patient_number
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Contact</b></td>
                  <td>
                    {{
                      PaymentReciept.patient_contact
                        ? PaymentReciept.patient_contact
                        : "---"
                    }}
                  </td>
                </tr>

                <tr>
                  <td><b>Reciept</b></td>
                  <td>
                    {{
                      PaymentReciept.payment_detail
                        ? PaymentReciept.payment_detail.reciept_no
                        : "--"
                    }}
                  </td>
                </tr>
              </table>
            </center>
            <hr />
            <div style="width: 100%">
              <b>Recieved:</b
              >{{
                this.thousandSeparator(
                  PaymentReciept.payment_detail
                    ? PaymentReciept.payment_detail.amount_paid
                    : "--"
                )
              }}/=
              <p>
                <b>Total:</b>
                {{
                  this.thousandSeparator(
                    PaymentReciept.total ? PaymentReciept.total : "0"
                  )
                }}/=
                <br />
                <b>Paid:</b>
                {{
                  this.thousandSeparator(
                    PaymentReciept.total ? this.PaymentReciept.total - balance : "0"
                  )
                }}/=
                <br />
                <b>Discount:</b>
                {{
                  this.thousandSeparator(
                    PaymentReciept.discount ? PaymentReciept.discount : "0"
                  )
                }}/=
                <br />
                <b>Balance:</b>
                {{ this.thousandSeparator(balance ? balance : "0") }}/=
              </p>
              <strong>SERVICES</strong>
              <p v-for="(serve, index) in PaymentReciept.services" :key="index">
                {{ serve.quantity }} {{ serve.service }}
                <b>{{ serve.cost }}/=</b>
              </p>
            </div>
            <center>
              <hr style="border-style: dashed; width: 97%" />
              <p>
                Signature ..........................................
                <br />Thank you for trusting
                <strong>
                  {{
                    PaymentReciept.clinic_name ? PaymentReciept.clinic_name : "---"
                  }}</strong
                >
                <br />For more inquiries call
                <strong>{{
                  PaymentReciept.clinic_contact ? PaymentReciept.clinic_contact : "---"
                }}</strong>
              </p>
              <p>
                Receipt reprinted by
                {{ PaymentReciept.printuser ? PaymentReciept.printuser : "--" }} via
                Clinic Plus Hospital Software
              </p>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
